<template>
  <Modal
    :width="720"
    :title="$t('appointment.formCreate.labels.searchAddress')"
    name="SELECT_CUSTOM_ADDRESS"
    actions
  >
    <template v-slot:body>
      <AddressSearch
        @address="setOthersAddress"
        :rules="rules.required"
        :focus="true"
        ref="addressSearch"
      />
    </template>
    <template v-slot:actions>
      <div class="d-flex">
        <v-btn
          @click="addAddress"
          :loading="isLoading"
          :disabled="!hasPostalCode || !hasStreetNumber"
          color="primary"
          elevation="0"
          large
        >
          {{ $t('appointment.formCreate.labels.addAddress') }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { required } from '@/util/defaultValidationRules'

import Modal from '@/components/app/Modal'
import AddressSearch from '@/components/app/AddressSearch'

export default {
  name: 'ModalCustomKeyAddress',

  components: {
    Modal,
    AddressSearch,
  },

  data() {
    return {
      isLoading: false,
      hasPostalCode: true,
      hasStreetNumber: true,
      rules: { required },
    }
  },

  computed: {
    ...mapGetters(['appointmentFields', 'appointmentAddresses']),
  },

  methods: {
    ...mapActions(['closeModal']),
    ...mapMutations(['setAppointmentFields', 'setAppointmentAddresses']),

    setOthersAddress({ address }) {
      const { key_location_options } = this.appointmentFields

      this.setAppointmentFields({
        key_location_options: {
          ...key_location_options,
          id: null,
          address,
          key_location: 'OTHER',
        },
        key_location_address: address,
      })
    },

    removeLastAddress(addressList) {
      let newAddresses = addressList

      if (addressList.some((address) => address.id === 'googleAddress')) {
        addressList.splice(addressList.length - 3, 3)
      }

      return newAddresses
    },

    addAddress() {
      this.isLoading = true
      const addresses = [...this.appointmentAddresses]

      Promise.resolve(this.removeLastAddress(addresses))
        .then((response) => {
          const othersGroup = [
            { header: this.$t('appointment.formCreate.labels.others') },
          ]
          const divider = [{ divider: true }]
          const address = [
            {
              id: 'googleAddress',
              address: this.appointmentFields.key_location_address,
              location: 'OTHER',
            },
          ]
          const googleAddress = response.concat(divider, othersGroup, address)
          this.closeModal('SELECT_CUSTOM_ADDRESS')
          this.setAppointmentAddresses(googleAddress)
          this.setOthersAddress({ address: this.appointmentFields.key_location_address })
          this.$emit('click', address)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
